/**
 * Shared by the visible home FAQ and its FAQPage structured data so crawler
 * content can never drift from what visitors actually read.
 */
export const homeFaqs = [
  {
    question: 'What freight services does Ship Smart Solutions provide?',
    answer:
      'We provide managed transportation, freight brokerage, dedicated capacity, warehousing and distribution, expedited freight, project logistics and specialized transportation solutions tailored to your supply chain.',
  },
  {
    question: 'Is Ship Smart Solutions an asset-based logistics provider?',
    answer:
      'Yes. We combine company-controlled equipment with a carefully managed carrier network, giving customers dependable capacity, greater flexibility and stronger control throughout the shipment lifecycle.',
  },
  {
    question: 'Can I track my shipment in real time?',
    answer:
      'Yes. Our visibility tools provide live shipment tracking, status updates and proactive communication from pickup through final delivery, helping your team stay informed at every stage.',
  },
  {
    question: 'What areas does Ship Smart Solutions serve?',
    answer:
      'We provide nationwide freight coverage across the contiguous United States. Cross-border and international logistics support may also be arranged based on your origin, destination and shipment requirements.',
  },
  {
    question: 'Do you handle temperature-controlled freight?',
    answer:
      'Yes. Our refrigerated transportation solutions support temperature-sensitive products with dependable reefer capacity, shipment visibility and careful handling throughout transit.',
  },
  {
    question: 'Can you transport oversized or specialized freight?',
    answer:
      'Yes. We coordinate flatbed, open-deck, step-deck, heavy-haul and project logistics solutions for oversized, overweight and complex shipments that require specialized planning and equipment.',
  },
  {
    question: 'Do you offer warehousing and distribution services?',
    answer:
      'Yes. We connect warehousing, inventory coordination, distribution and transportation into one streamlined solution designed to improve efficiency and reduce unnecessary supply-chain complexity.',
  },
  {
    question: 'How do I request a freight quote?',
    answer:
      'Submit your pickup and delivery locations, freight type, weight, dimensions, equipment requirements and preferred timeline through our quote form. Our logistics team will review the details and contact you with the right solution.',
  },
] as const;
